import { LoginPage } from './login_page'

export default LoginPage
